var $ = require('../../modules/$');
module.exports = function create(P, D){
  return $.create(P, D);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/fn/object/create.js
 ** module id = 110
 ** module chunks = 0
 **/